import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img
          src={process.env.PUBLIC_URL + '/logo.png'}
          alt="CoffeemonkCodes Logo"
          style={{ width: 80, height: 80, borderRadius: 16, marginBottom: 24, boxShadow: '0 4px 24px #0002' }}
        />
        <h1>CoffeemonkCodes</h1>
        <p style={{ maxWidth: 500, margin: '1rem auto' }}>
          A community built by technical leaders from Microsoft, Yahoo, and other big tech companies. <br />
          Discuss code, help others, collaborate, and more.
        </p>
        <a
          className="discord-invite"
          href="https://discord.gg/3SHpfdQvU6"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join our Discord
        </a>
      </header>
    </div>
  );
}

export default App;
